import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton"]

  handleSuccess(event) {
    // Check if the form submission was successful (not an error response)
    if (event.detail.success) {
      // Find the modal controller and close it
      const modalElement = this.element.closest('[data-controller*="modal"]')
      if (modalElement) {
        const modalController = this.application.getControllerForElementAndIdentifier(
          modalElement,
          "modal"
        )
        if (modalController) {
          modalController.close()
        }
      }

      // Reset the form
      this.element.reset()
    }
  }
}
